import { Text } from "@mantine/core";
import { isNumber } from "@tiptap/react";
import { type ILogbook } from "src/interfaces";

import { getStatusValue } from "../../components/pages/Summary/ReviewsAndAudits/RevAud.utils";
import { StatusGoldCircle } from "../../components/pages/Summary/ReviewsTable/ReviewsTable.styled";
import { mapLogbookSelect } from "../../utils";
import { type ISummaryItem } from "./Summary.types";
import type { ComboboxData } from "@mantine/core";

interface IStatus {
  status: string;
  color: string;
  fontWeight: string;
}

export const summaryStatusList: Record<number, IStatus> = {
  0: { status: "Draft", color: "red.9", fontWeight: "bold" },
  1: { status: "Open", color: "orange.4", fontWeight: "bold" },
  2: { status: "Re-Verify", color: "orange.4", fontWeight: "bold" },
  3: { status: "Yacht Verified", color: "green.8", fontWeight: "bold" },
  4: { status: "Review", color: "", fontWeight: "" },
  50: { status: "Pending Review", color: "", fontWeight: "" },
  200: { status: "Internal Review Verified", color: "", fontWeight: "" },
  210: { status: "Superintendent Visit Verified", color: "", fontWeight: "" },
  220: { status: "Manager Visit Verified", color: "", fontWeight: "" },
  230: { status: "Periodic Inspection Verified", color: "", fontWeight: "" },
  240: { status: "Management Review", color: "", fontWeight: "" },
  250: { status: "Yacht Review", color: "", fontWeight: "" },
  1000: { status: "Audit", color: "green.8", fontWeight: "bold" },
  5: { status: "Further Info Requested", color: "", fontWeight: "" },
  6: { status: "Further Info Provided", color: "", fontWeight: "" },
  99: { status: "Withdrawn", color: "gray.7", fontWeight: "bold" },
};

export const rStatusList: Record<number, IStatus> = {
  0: { status: "Pending", color: "yellow.6", fontWeight: "bold" },
  1: { status: "Action Required", color: "red.8", fontWeight: "bold" },
  10: { status: "Completed", color: "blue.5", fontWeight: "bold" },
};

export const mapSummary = (data: any) => {
  const auditor = data?.data?.auditor;
  const nonauditor = data?.data?.nonauditor;
  const expired = data?.data?.review?.audit?.expired;
  const yachtuser = data?.data?.yachtuser;
  const audit = data?.data?.review?.audit;
  const pages = data.data.review.pages;
  const reviews: ISummaryItem[] =
    data.data.review?.data?.map((review: any) => {
      let comments = review.comments ?? [];
      if (typeof comments === "string") comments = JSON.parse(comments);
      return { ...review, comments };
    }) ?? [];
  const required: ISummaryItem[] =
    data.data.review?.required?.map((review: any) => {
      let comments = review.comments ?? [];
      if (typeof comments === "string") comments = JSON.parse(comments);
      return { ...review, comments };
    }) ?? [];

  const logbooks: ComboboxData = mapLogbookSelect(data.data.review.logbooks);

  let comments = data?.data?.review?.audit?.data?.comments;
  if (typeof comments === "string") comments = JSON.parse(comments);
  return {
    reviews,
    required,
    logbooks,
    pages,
    comments,
    audit,
    yachtuser,
    expired,
    nonauditor,
    auditor,
  };
};

export const renderAuditName = (status: number) => {
  const getName = () => {
    switch (status) {
      case 1000:
        return "Audit";
      case 240:
        return "Managment Review";
      case 250:
        return "Yacht Review";
    }
  };

  return (
    <Text size="xs" c="main.4">
      {getName()}
    </Text>
  );
};
export const renderStatusBadge = (type: number) => {
  return <StatusGoldCircle>{getStatusValue(type)}</StatusGoldCircle>;
};